import { createTheme } from '@mantine/core';
import type { CSSVariablesResolver } from '@mantine/core';
import { colors } from './colors';
import { layout } from './layout';
import { components } from './components';

/**
 * アプリケーションテーマ
 */
export const theme = createTheme({
  primaryColor: 'blue',

  // カスタムブレイクポイント
  breakpoints: {
    xs: '36em',
    sm: '48em',
    md: '62em',
    lg: '75em',
    xl: '88em',
  },

  components,

  other: {
    colors,
    layout,
  },
});

/**
 * CSS変数リゾルバー
 * テーマ値をCSS変数として公開
 */
export const cssVariablesResolver: CSSVariablesResolver = () => ({
  variables: {
    // 行の高さ
    '--mantine-line-height': '1.5',

    // カスタムカラー変数
    '--app-color-primary': colors.primary,
    '--app-color-border': layout.border.color,
    '--app-color-border-light': layout.border.colorLight,
    '--app-color-bg-page': colors.background.page,
    '--app-color-bg-card': colors.background.card,
    '--app-color-bg-panel': colors.background.panel,
    '--app-color-bg-hover': colors.gray[50],
    '--app-color-bg-selected': colors.selection.background,
    '--app-color-text-primary': colors.gray[900],
    '--app-color-text-secondary': colors.gray[600],
    '--app-color-success': colors.semantic.success,
    '--app-color-warning': colors.semantic.warning,
    '--app-color-error': colors.semantic.error,

    // レイアウト変数
    '--app-sidebar-width': `${layout.sidebar.width}px`,
    '--app-header-height': `${layout.header.height}px`,
    '--app-right-panel-width': `${layout.rightPanel.width}px`,
    '--app-border-radius': `${layout.border.radius}px`,
  },
  light: {},
  dark: {},
});

// 再エクスポート
export { colors } from './colors';
export { layout } from './layout';
export type { Colors } from './colors';
export type { Layout } from './layout';
